import React from 'react';

export interface MatrixDonutItem {
  name: string;
  value: number;
  max: number;
}

interface MatrixDonutGroupProps {
  data: MatrixDonutItem[];
}

const MatrixDonutGroup: React.FC<MatrixDonutGroupProps> = ({ data }) => {
  return (
    <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'flex-start', padding: '0' }}>
      {data.map((item, index) => {
        const percentage = Math.min(100, Math.max(0, (item.value / item.max) * 100));
        
        // Color mapping with lighter, brighter theme
        let strokeColor = '#10b981'; // >= 75% Bright Green
        if (percentage < 50) strokeColor = '#f43f5e'; // < 50% Bright Red/Rose
        else if (percentage < 75) strokeColor = '#f59e0b'; // < 75% Bright Orange

        const radius = 34;
        const strokeWidth = 10;
        const circumference = 2 * Math.PI * radius;
        const strokeDashoffset = circumference - (percentage / 100) * circumference;

        return (
          <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '104px' }}>
            <div style={{ position: 'relative', width: '84px', height: '84px', marginBottom: '8px' }}>
              <svg width="84" height="84" viewBox="0 0 84 84" style={{ transform: 'rotate(-90deg)' }}>
                {/* Background circle */}
                <circle
                  cx="42"
                  cy="42"
                  r={radius}
                  fill="transparent"
                  stroke="#e2e8f0"
                  strokeWidth={strokeWidth}
                />
                {/* Progress circle */}
                <circle
                  cx="42"
                  cy="42"
                  r={radius}
                  fill="transparent"
                  stroke={strokeColor}
                  strokeWidth={strokeWidth}
                  strokeDasharray={circumference}
                  strokeDashoffset={strokeDashoffset}
                  strokeLinecap="round"
                  style={{ transition: 'stroke-dashoffset 1s ease-in-out' }}
                />
              </svg>
              {/* Score text matching the large, clean donut style */}
              <div style={{ 
                position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', 
                display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}>
                <span style={{
                  fontSize: '18px',
                  fontWeight: 800,
                  color: strokeColor,
                  whiteSpace: 'nowrap',
                }}>
                  {Math.round(percentage)}%
                </span>
              </div>
            </div>
            {/* Label text */}
            <span style={{ 
              fontSize: '12px', 
              fontWeight: 600, 
              color: '#334155', 
              textAlign: 'center', 
              lineHeight: 1.25 
            }}>
              {item.name}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default MatrixDonutGroup;
